<template>
<div>
    <div class="top">
        <div class="cont">
            <div class="logo flex">
                <div class="logo-image">
                    <img :src="require('../../assets/images/new_logo.png')" />
                </div>
                <div>企业注册</div>
            </div>
        </div>
    </div>
    <div class="chose-tabs flex flex-center">
        <div class="chose-item flex flex-center" :class="{
            active: item.path.includes(routePath)
        }" v-for="(item, index) in list" :key="index">
            <div class="index">{{index + 1}}</div>
            <div class="label"> {{item.title}} </div>
        </div>
    </div>
    <div class="main-cont">
        <router-view></router-view>
    </div>
</div>
</template>
<script>
export default{
    data(){
        return{
            list: [
                {
                    title: '账户设置',
                    path: [
                        '/register/step'
                    ]
                },
                {
                    title: '企业设置',
                    path: ['/register/join', '/register/hrapply', '/register/create']
                },
                {
                    title: '注册完成',
                    path: ['/register/regsuc']
                }
            ]
        }
    },
    computed: {
        routePath () {
            return this.$route.path
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/less/base.less');
@top-height: 64px;
.top{
    height: @top-height;
    // line-height: @top-height;
    background: @color-primary;
    font-size: 16px;
    color: #fff;
    display: flex;
    align-items: center;
    .logo{
        align-items: flex-end;
    }
    .logo-image{
        height: 35px;
        img{
            height: 100%;
            width: auto;
        }
    }
    .cont{
        width: 1220px;
        margin: 0 auto;
    }
}
.chose-tabs{
    padding-top: 42px;
    line-height: 66px;
    border-bottom: 1px solid #F1F1F1;
    .chose-item{
        width: 156px;
        margin: 0 16px;
        font-size: 20px;
        font-weight: 600;
        color: @color-gray;
        .index{
            width: 26px;
            height: 26px;
            border-radius: 50%;
            background: #F1F1F1;
            font-size: 14px;
            line-height: 26px;
            text-align: center;
            margin-right: 8px;
        }
        &.active{
            color: #333333;
            position: relative;
            .index{
                background:  @color-primary;
                color: #fff;
            }
            &::after{
                content: '';
                display: block;
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 2px;
                background: @color-primary;
            }
        }
    }
}
.main-cont{
    display: flex;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// layout.vue?869eb4fc